module.exports = __webpack_public_path__ + "static/media/fivestart.701cdd63.svg";